module.exports = __webpack_public_path__ + "img/brand-right-shapes.d614c9c9.svg";